const primaryColor = '#00BFA5';
const textGray = '#263238';
const fadedGray = '#37474F';
const lightGray = '#8B8B8B';
const red = '#cd1619';
const blueGray = '#455a64';
const lightBlue = '#e8fffc';
const almostWhite = '#f5f6f6';

export {
  primaryColor,
  textGray,
  fadedGray,
  lightGray,
  red,
  blueGray,
  lightBlue,
  almostWhite
};



// WEBPACK FOOTER //
// ./src/utils/colors.js